/**
 * Stole from https://github.com/szchenghuang/debounce-async
 * debounce(func, [wait=0], [options={}])
 *
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false] Specify invoking on the leading edge of the timeout.
 * @param {cancelObj} [options.cancelObj='canceled'] Specify the error object to be rejected.
 * @returns {Function} Returns the new debounced function.
 */
function debounce(func, wait = 0, { leading = false } = {}) {
  let timerId;
  let latestResolve;
  let shouldCancel;

  function invokeAtLeading(args, resolve) {
    func.apply(this, args).then(resolve);
    shouldCancel = false;
  }

  function invokeAtTrailing(args, resolve) {
    if (!shouldCancel || resolve === latestResolve) {
      func.apply(this, args).then(resolve);
      shouldCancel = false;
      clearTimeout(timerId);
      timerId = latestResolve = null;
    }
  }

  return function(...args) {
    if (!latestResolve) {
      // The first call since last invocation.
      return new Promise((resolve) => {
        latestResolve = resolve;
        if (leading) {
          invokeAtLeading.apply(this, [args, resolve]);
        } else {
          timerId = setTimeout(
            invokeAtTrailing.bind(this, args, resolve),
            wait,
          );
        }
      });
    }

    shouldCancel = true;
    return new Promise((resolve) => {
      latestResolve = resolve;
      timerId = setTimeout(invokeAtTrailing.bind(this, args, resolve), wait);
    });
  };
}

export default debounce;
